import { useNavigate } from "react-router";
import BreadCrumbsComponent from "../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../SharedComponents/Title/Title";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { SettingsPage } from "../SetupTenant/settingPage/SettingsPage";
import { StepperDTO } from "../../models/componentModels/StepperDTO";
import { Card } from "@forge/common";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../localization/keys";

export const EditSettings = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const onBackBtn = () => {
    navigate(-1);
  };

  const crumbs = [
    {
      id: "create-tenant",
      label: useSelector(
        (state: RootState) => state.cart.tenantDeatailsByTenantId.tenantId
      ),
    },
    {
      id: "edit-tenant",
      label: t(localeKeyMap.editTenant),
    },
  ];

  const initialStepperState: StepperDTO = {
    currentStep: "EditTenant",
    steps: [
      {
        id: "CreateTenant",
        status: undefined,
        title: t(localeKeyMap.enterTenantDetails),
      },
      {
        id: "Settings",
        status: undefined,
        title: t(localeKeyMap.addParameters),
      },
      {
        id: "Summary",
        status: undefined,
        title: t(localeKeyMap.summary),
      },
    ],
  };
  return (
    <>
      <BreadCrumbsComponent
        crumbs={crumbs}
        backbutton={true}
        backButtonHandler={onBackBtn}
      />
      <Title title={t(localeKeyMap.editSettings)} className="p-t15 p-b20" />

      <Card className="p-15 border-gray border-radius-10 create_tenant app-settings-card-container">
        <SettingsPage
          stepperState={initialStepperState}
          setStepperState={() => {}}
        />
      </Card>
    </>
  );
};
